import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { ReactComponent as FacebookIcon } from '../../../../../assets/logos/fb-circle-icon.svg'
import { ReactComponent as GoogleIcon } from '../../../../../assets/logos/google-icon.svg'
import { ReactComponent as DV360Icon } from '../../../../../assets/logos/dv360-icon.svg'
import { ReactComponent as TikTokIcon } from '../../../../../assets/logos/tiktok-circle-icon.svg'

import {
  DV_360_PROVIDER_PLATFORM,
  FACEBOOK_PROVIDER_PLATFORM,
  GOOGLE_PROVIDER_PLATFORM,
  TIKTOK_PROVIDER_PLATFORM
} from '../../../../../constants/selectLists/platformList'

import useStyles from './styles'

const ProviderIcon = ({ provider, className }) => {
  const classes = useStyles()

  return (
    <div className={classnames(classes.providerIconWrapper, className)}>
      {provider === FACEBOOK_PROVIDER_PLATFORM && <FacebookIcon className={classes.providerIcon} />}
      {provider === GOOGLE_PROVIDER_PLATFORM && <GoogleIcon className={classes.providerIcon} />}
      {provider === DV_360_PROVIDER_PLATFORM && <DV360Icon className={classes.providerIcon} />}
      {provider === TIKTOK_PROVIDER_PLATFORM && <TikTokIcon className={classes.providerIcon} />}
    </div>
  )
}

ProviderIcon.propTypes = {
  provider: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default ProviderIcon
